import { maxWidth, Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  form: {
    '&&': {
      display: 'flex',

      [theme.breakpoints.down('tablet')]: {
        alignItems: 'center',
        flexDirection: 'column',
      },

      [theme.breakpoints.up('tablet')]: {
        gap: SPACES.xxxxxxl,
        flexWrap: 'wrap',
      },
    },
  },
  formWrapper: {
    '&&': {
      position: 'relative',
      flexDirection: 'column',

      [theme.breakpoints.down('tablet')]: {
        alignItems: 'center',
        gap: SPACES.xxl,
        marginBottom: SPACES.xxl,
      },

      [theme.breakpoints.up('tablet')]: {
        gap: '2.5rem',

        maxWidth: 800,
      },
      [theme.breakpoints.up('laptop')]: {
        padding: SPACES.xs,
        maxWidth: 840,
      },
    },
  },
  themeChoseBlock: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  themeBlock: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.625rem',
  },
  mainImageWrapper: {
    '&&': {
      marginRight: 'auto',
    },
  },
  inputsRowWrapper: {
    display: 'flex',
    width: '100%',

    [theme.breakpoints.down('tablet')]: {
      flexWrap: 'wrap',
      gap: SPACES.xxl,
    },
    [theme.breakpoints.up('tablet')]: {
      maxHeight: 200,
      justifyContent: 'space-between',
    },
    [theme.breakpoints.between('tablet', 'laptop')]: {
      gap: SPACES.xxs,
    },
    [theme.breakpoints.up('laptop')]: {
      gap: SPACES.xxxxxl,
    },
  },
  inputWrapper: {
    '&&': {
      width: '100%',
      gap: SPACES.xs,

      display: 'flex',
      flexDirection: 'column',
      alignItems: 'end',
    },
  },

  // * Settings
  settingsItemsWrapper: {
    '&&': {
      display: 'flex',
      width: '100%',
      [theme.breakpoints.down('tablet')]: {
        flexDirection: 'column',
        gap: SPACES.xs,
      },
      [theme.breakpoints.between('tablet', 'laptop')]: {
        gap: SPACES.xxs,
        justifyContent: 'space-between',
      },
      [theme.breakpoints.up('laptop')]: {
        gap: 40,
      },
    },
  },
  itemSubtitle: {
    margin: 0,

    [theme.breakpoints.down('tablet')]: {
      marginBottom: SPACES.xs,

      fontWeight: FONTS.WEIGHTS.light,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.33,

      color: theme.palette.custom.grey2,
    },
    [theme.breakpoints.up('tablet')]: {
      marginBottom: SPACES.xxxxxl,

      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.m,
      lineHeight: 1.4,

      color: theme.palette.custom.darkBlue2,
    },
  },
  itemBorder: {
    border: `1px solid ${theme.palette.custom.grey}`,

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      padding: `${SPACES.xs} ${SPACES.xxl} ${SPACES.xxl} ${SPACES.xxl}`,
      borderRadius: 10,
    },

    [theme.breakpoints.up('tablet')]: {
      padding: `40px`,
      borderRadius: 15,
    },
  },
  settingsItemWrapper: {
    [theme.breakpoints.down('tablet')]: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
    },
    [theme.breakpoints.up('tablet')]: {
      width: 390,

      padding: '40px',
    },
  },
  settingsItems: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
  },
  settingsItem: {
    [theme.breakpoints.up('tablet')]: {
      maxWidth: '362px',
      height: '30px',
    },
  },
  deleteButtonWrapper: {
    display: 'flex',

    [theme.breakpoints.down('tablet')]: {
      flexDirection: 'column',
      gap: SPACES.s,
    },
    [theme.breakpoints.up('tablet')]: {
      justifyContent: 'space-between',
    },
  },
  settingsWrapper: {
    '&&': {
      marginTop: SPACES.xxl,
    },
  },
  deleteButton: {
    '&&': {
      borderRadius: '20px',

      fontSize: FONTS.SIZES.s,
      textTransform: 'none',
      fontWeight: FONTS.WEIGHTS.bold,
      backgroundColor: theme.palette.custom.warning2,

      '&:disabled': {
        backgroundColor: theme.palette.custom.secondary,
        color: theme.palette.custom.darkBlue2,
      },

      '&:hover, &:focus': {
        backgroundColor: '#d9434b',
      },

      width: 200,
      height: 40,

      [theme.breakpoints.down('tablet')]: {
        marginLeft: 'auto',
      },
    },
  },

  loginProvidersModalWrapper: {
    '&&': {
      minHeight: 150,

      padding: '35px 20px 20px',
      maxHeight: 'calc(100vh - 100px)',
      maxWidth: '300px',
      width: '85vw',

      outline: 'none',
    },
  },

  deleteIcon: {
    '&&': {
      width: '24px',
      height: '24px',
    },
  },
}))

export { useStyles }
